import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-subsidy-info-modal',
  templateUrl: './subsidy-info-modal.component.html',
  styleUrls: ['./subsidy-info-modal.component.scss'],
})
export class SubsidyInfoModalComponent implements OnInit {
  @Input() subsidyAmount!: number;

  constructor(private readonly modalService: ModalService) {}

  ngOnInit() {
    return;
  }

  onDismiss(): void {
    this.modalService.dismiss();
  }
}
